import { mutatorAction } from "satcheljs";
import { TeamSetupPickerViewState } from "../schema/TeamSetupPickerViewState";

export default mutatorAction("CLOSE_TEAM_SETUP_PICKER",
    function closeTeamSetupPicker(viewState: TeamSetupPickerViewState) {
        viewState.isOpen = false;
    });